// src/app/core/guards/module-locked.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PlanService } from '@app/core/services/plan.service';
import { LAST_APP_KEY } from '@app/core/guards/launcher.guard';
import { MODULE_ROUTES } from '@app/core/constants/module-routes';

// Protège les routes de modules verrouillables : ouvrir directement l'URL d'un
// module verrouillé (cadenas caser) doit ramener au lanceur avec le dialogue
// d'activation ouvert, plutôt que de laisser charger un écran inutilisable.
// Un module MASQUÉ ramène au lanceur sans dialogue.
export const moduleLockedGuard: CanActivateFn = async (route) => {
  const planService = inject(PlanService);
  const router      = inject(Router);

  const code = route.data['module'];
  if (!code) return true;

  await planService.loadOnce();

  // Masqué : retour au lanceur SANS dialogue d'activation — le module n'est
  // pas proposé à ce caser, on ne le lui présente pas.
  if (planService.isModuleHidden(code)) {
    oublierDerniereApp(code);
    return router.createUrlTree(['/launcher']);
  }
  if (planService.isModuleLocked(code)) {
    oublierDerniereApp(code);
    return router.createUrlTree(['/launcher'], { queryParams: { locked: code } });
  }
  return true;
};

/**
 * La connexion rouvre la dernière application mémorisée (LAST_APP_KEY, cf.
 * getPostLoginRedirect). Si c'est ce module verrouillé, chaque connexion
 * rebondirait sur le dialogue : on oublie ce souvenir, le lanceur reprend la main.
 */
function oublierDerniereApp(code: string): void {
  if (typeof localStorage === 'undefined') return;
  const route = MODULE_ROUTES[code.trim().toLowerCase()];
  if (route && localStorage.getItem(LAST_APP_KEY) === route) {
    localStorage.removeItem(LAST_APP_KEY);
  }
}
